import './Dashboard.module.css'

import React from 'react'
import { useState, useEffect } from 'react'
import { BackButton, LoginButton } from '../../../components/layout/NavBar'
import { Services } from '@/services/services'
import { useNavigate, useParams } from 'react-router-dom'

import { Translates } from '@/services/repository/i18n'
import { CurrentSession } from '@/services/repository/session'
import {  MainPageLayout } from '@/components/layout/MainLayout'
import { useLogin } from '@/context/login'
import { Machine } from '@/services/model/machine'
import { useModal } from '@/components/modal/Modal'
import { MachinePath } from './Common'
import { Roles } from '@/services/repository/users'
import { MachineStatuses } from './statuses'
import { CommunalLangsButton } from '@/components/layout/Langs'
import { Spinner } from '@/components/spinner'
import { DashboardMenu } from './components/menu/main'


export const CommunalMachineDashboard = ({ services, session }: { services: Services, session: CurrentSession | undefined }) => {
  const mid = useParams().mid
  const navigate = useNavigate()
  const { redirectToLogin } = useLogin()
  const [machine, setMachine] = useState<Machine>()
  const [translates, setTranslates] = useState<Translates>()
  const { openModal } = useModal()
  const fullAccess = session?.user.role == Roles.SuperAdmin || session?.user.role == Roles.CompanyAdmin || session?.user.role == Roles.Serviceman || session?.user.role == Roles.CompanyManager

  useEffect(() => {
    if (session) {
      setTranslates(session.translates)
      return
    }
    services.i18n.get('main').then(setTranslates)
  }, [session])

  useEffect(() => {
    fetch(`/api/communal/machines/byid/${mid}`).then((response) => {
      return response.json()
    }).then((data) => {
      setMachine(data)
    })
  }, [mid])

  if (!machine || !translates) {
    return <Spinner />
  }

  return <MainPageLayout pageName='communal-dashboard' services={services} translates={translates} session={session} path={MachinePath({ session, translates, machine })}
    navbarLeft={!session ? <LoginButton translates={translates} /> : <BackButton services={services} translates={translates} replaceUrl='/' />}
    navbarRight={<CommunalLangsButton session={session} services={services} translates={translates} />} >
    <div className="container">

      {machine.machineType?.manufacturer ? <div className='machine-logo-wrap'>
        {machine.machineType?.manufacturer}
        {/* <img src={`/public/img/machines/manufacture/${machine.machineType?.manufacturer}/logo.png`} /> */}
      </div> : null}

      {machine.machineType?.model ? <div className='machine-type'>
        {translates.for(`machine.types.${machine.machineType?.category}`)}
      </div> : null}

      {machine.machineType?.model ? <div className='machine-type-row'>
        <span className='label'>{translates.for('forms.machine.fields.model.title')}: </span>
        <span className='value'>{machine.machineType?.model}</span>
      </div> : null}

      {machine.internalNumber ? <div className='machine-type-row'>
        <span className='label'>{translates.for('machine.internal_number')}: </span>
        <span className='value'>{machine.internalNumber}</span>
      </div> : null}

      {/* <div className='machine-name'>{machine.name}</div> */}
      {MachineStatuses(translates, machine)}

      <DashboardMenu machine={machine} />
    </div>
  </MainPageLayout>
}
